import { useEffect, useState } from 'react'

export const ClientRender = ({ children }) => {
  const [render, setRender] = useState(false)

  useEffect(() => {
    setRender(true)
  }, [])

  if (render) {
    return children
  } else return null
}
